import Validator from 'validatorjs';
import { VALIDATION } from "../../AppConstants";
import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";

Validator.registerImplicit('need_lienholder', function (this: any, value, requirement, attribute) {
    const vehicle = this.validator.input;

    if (false === vehicle.hasLienholder) {
        return true;
    }
    return !!value;
});

const rules = {
    vin: 'required',
    lienholder: {
        name: 'need_lienholder',
        address: {
            street: 'need_lienholder',
            city: 'need_lienholder',
            zipCode: 'need_lienholder',
            stateCode: 'need_lienholder'
        }
    },
    garagingAddress: {
        street: 'required',
        city: 'required',
        zipCode: 'required',
        stateCode: 'required',
    },
    wasSalvaged: 'required',
    vehicleUse: 'required'
};

const customErrorMessages = {
    "need_lienholder": VALIDATION.REQUIRED
};

export const allFieldsValidation = (data) => {
    return allFieldsValidationCommon(data.vehicle, rules, { ...customErrorMessagesCommon, ...customErrorMessages });
};